<template>
  <div id="Fireworks"></div>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue"
import colorTool from "@/utils/colorTool"
import freeImg from "@/utils/freeImg"
const {freeImages} = freeImg()
const {defaultWidth, defaultHeight} = defaultValue()
const {changeToRgb, rgbToHsb, hsbToHsl} = colorTool()

const props = defineProps(['currentValue', 'effectTheme', 'controlMode'])


const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let nowTemperature = ref(null)
// let animateSpeed = ref(10)
let animateRange = ref(0.2)
let backgroundHsbColor = ref([0,0,0])
let backgroundColor = ref('rgb(0,0,0)')
let imgUrl = ref(null)
let imagePathType = ref('')
let backgroundImage = ref('')
let high = ref(null)
let low = ref(null)
let drawPot = ref(0)
let colorLow = ref([])
let colorHigh = ref([])

let currentColorArr = reactive({arr: []})

const handleGetAnimateHSBAndRange = (high, low, now = 30, colorHigh, colorLow) => {
  // 高低差 range
  let lowHeightRange = Math.ceil((high - low) / 9) // 將高低差 分為 10個單位, 1單位

  let lowHeightColorRange

  let range = Math.trunc((now - low) / lowHeightRange)

  if (range <= 3) {
    lowHeightColorRange = 1
    animateRange.value = 0.1 // 設定煙火數量 少
  }
  else if (range >= 7 ) {
    lowHeightColorRange = 10
    animateRange.value = 0.3 // 設定煙火數量 多
  }
  else {
    lowHeightColorRange = range
    animateRange.value = 0.2 // 設定煙火數量 普通
  }


  if (lowHeightColorRange === 1 ) currentColorArr.arr = colorLow.map(color => rgbToHsb(color))
  else if (lowHeightColorRange >= 10) currentColorArr.arr = colorHigh.map(color => rgbToHsb(color))
  else {
    const colorHighOne = rgbToHsb(colorHigh[0])
    const colorHighTwo = rgbToHsb(colorHigh[1])
    const colorHighThree = rgbToHsb(colorHigh[2])
    const colorHighFour = rgbToHsb(colorHigh[3])
    const colorHighFive = rgbToHsb(colorHigh[4])
    const colorHighSix = rgbToHsb(colorHigh[5])

    const colorLowOne = rgbToHsb(colorLow[0])
    const colorLowTwo = rgbToHsb(colorLow[1])
    const colorLowThree = rgbToHsb(colorLow[2])
    const colorLowFour = rgbToHsb(colorLow[3])
    const colorLowFive = rgbToHsb(colorLow[4])
    const colorLowSix = rgbToHsb(colorLow[5])

    const nowColorOne = [
      (lowHeightColorRange * colorHighOne[0] + (10 - lowHeightColorRange) * colorLowOne[0]) / 10,
      (lowHeightColorRange * colorHighOne[1] + (10 - lowHeightColorRange) * colorLowOne[1]) / 10,
      (lowHeightColorRange * colorHighOne[2] + (10 - lowHeightColorRange) * colorLowOne[2]) / 10,
    ]
    const nowColorTwo = [
      (lowHeightColorRange * colorHighTwo[0] + (10 - lowHeightColorRange) * colorLowTwo[0]) / 10,
      (lowHeightColorRange * colorHighTwo[1] + (10 - lowHeightColorRange) * colorLowTwo[1]) / 10,
      (lowHeightColorRange * colorHighTwo[2] + (10 - lowHeightColorRange) * colorLowTwo[2]) / 10,
    ]
    const nowColorThree = [
      (lowHeightColorRange * colorHighThree[0] + (10 - lowHeightColorRange) * colorLowThree[0]) / 10,
      (lowHeightColorRange * colorHighThree[1] + (10 - lowHeightColorRange) * colorLowThree[1]) / 10,
      (lowHeightColorRange * colorHighThree[2] + (10 - lowHeightColorRange) * colorLowThree[2]) / 10,
    ]
    const nowColorFour = [
      (lowHeightColorRange * colorHighFour[0] + (10 - lowHeightColorRange) * colorLowFour[0]) / 10,
      (lowHeightColorRange * colorHighFour[1] + (10 - lowHeightColorRange) * colorLowFour[1]) / 10,
      (lowHeightColorRange * colorHighFour[2] + (10 - lowHeightColorRange) * colorLowFour[2]) / 10,
    ]
    const nowColorFive = [
      (lowHeightColorRange * colorHighFive[0] + (10 - lowHeightColorRange) * colorLowFive[0]) / 10,
      (lowHeightColorRange * colorHighFive[1] + (10 - lowHeightColorRange) * colorLowFive[1]) / 10,
      (lowHeightColorRange * colorHighFive[2] + (10 - lowHeightColorRange) * colorLowFive[2]) / 10,
    ]
    const nowColorSix = [
      (lowHeightColorRange * colorHighSix[0] + (10 - lowHeightColorRange) * colorLowSix[0]) / 10,
      (lowHeightColorRange * colorHighSix[1] + (10 - lowHeightColorRange) * colorLowSix[1]) / 10,
      (lowHeightColorRange * colorHighSix[2] + (10 - lowHeightColorRange) * colorLowSix[2]) / 10,
    ]

    currentColorArr.arr = [
      nowColorOne,
      nowColorTwo,
      nowColorThree,
      nowColorFour,
      nowColorFive,
      nowColorSix
    ]

    if (
        colorHighOne[0] === colorLowOne[0] &&
        colorHighOne[1] === colorLowOne[1] &&
        colorHighOne[2] === colorLowOne[2]
    ) {
      currentColorArr.arr[0] = colorHighOne
    }
    if (
        colorHighTwo[0] === colorLowTwo[0] &&
        colorHighTwo[1] === colorLowTwo[1] &&
        colorHighTwo[2] === colorLowTwo[2]
    ) {
      currentColorArr.arr[1] = colorHighTwo
    }
    if (
        colorHighThree[0] === colorLowThree[0] &&
        colorHighThree[1] === colorLowThree[1] &&
        colorHighThree[2] === colorLowThree[2]
    ) {
      currentColorArr.arr[2] = colorHighThree
    }
    if (
        colorHighFour[0] === colorLowFour[0] &&
        colorHighFour[1] === colorLowFour[1] &&
        colorHighFour[2] === colorLowFour[2]
    ) {
      currentColorArr.arr[3] = colorHighFour
    }
    if (
        colorHighFive[0] === colorLowFive[0] &&
        colorHighFive[1] === colorLowFive[1] &&
        colorHighFive[2] === colorLowFive[2]
    ) {
      currentColorArr.arr[4] = colorHighFive
    }
    if (
        colorHighSix[0] === colorLowSix[0] &&
        colorHighSix[1] === colorLowSix[1] &&
        colorHighSix[2] === colorLowSix[2]
    ) {
      currentColorArr.arr[5] = colorHighSix
    }
  }
}




function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}


const fireworksAnimate = (sketch) => {
  let cw = defaultWidth.value
  let ch = defaultHeight.value
  let bg
  let vid
  let backgroundAlpha = 50 // 控制 煙火軌跡長短

  let particles = [];
  let fireworks = [];

  const maxVx = 1
  //重力加速度
  const g = 0.04

  class Particle {
    constructor(x, y, color, size, vx, vy, life) {
      this.active = true;
      this.x = x;
      this.y = y;
      this.vx = vx;
      this.vy = vy;
      this.color = color;
      this.size = size;
      this.defaultSize = size;
      this.life = life;
      this.defaultLife = life;
    }

    draw() {
      sketch.push();
      sketch.fill(this.color);
      sketch.drawingContext.shadowBlur = 24;
      sketch.drawingContext.shadowColor = sketch.color(this.color);
      sketch.circle(this.x, this.y, this.size);
      sketch.pop();
    }

    move() {
      this.x += this.vx;
      this.y += this.vy;
      this.vy += g;

      if (this.life <= 0) {
        this.active = false;
      }
      this.size = this.defaultSize * this.life / this.defaultLife

      this.life -= 0.7;
    }
  }

  class FireWorkBall extends Particle {
    constructor(
        x,
        y,
        color,
        size,
        vx= sketch.random(-maxVx, maxVx),
        vy=-sketch.random((ch*g)**0.5, (ch*g*1.95)**0.5)
    ) {
      super(x, y, color, size, vx, vy, 1);
    }

    move() {
      this.x += this.vx;
      this.y += this.vy;
      this.vy += g;

      if (this.vy >= 0) {
        this.explode();
      }
    }

    explode() {
      for (let i=0; i<40; i++) {
        const vec = p5.Vector.random2D().mult(sketch.random(2, 5));
        particles.push(new Particle(
            this.x,
            this.y,
            this.color,
            sketch.random(2,4),
            vec.x,
            vec.y,
            sketch.random(40, 60) * sketch.random(0.7, 1.3)
        ));
      }
      this.active = false;
    }
  }

  sketch.setup = function () {
    sketch.createCanvas(cw, ch);
    sketch.colorMode(sketch.HSB, 360, 100, 100, 255);
    // animate
    sketch.background(...backgroundHsbColor.value, backgroundAlpha);
    sketch.noStroke();
    bg = ''
    vid = ''
    fireworks = []
    particles = []

    if (
        imagePathType.value !== 'gif' &&
        imagePathType.value !== 'mp4' &&
        imagePathType.value !== 'webm' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) bg = sketch.loadImage(imgUrl.value)

    // 若 imgUrl.value .gif
    if (imagePathType.value === 'gif' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) {
      bg = sketch.createImg(imgUrl.value)
      bg.style('background-color', `${backgroundColor.value}`)
      bg.style('z-index', '-1')
      // 設置 背景圖 position
      bg.size(cw, ch)
      bg.position(0,0)
      // 將 canvas background 切換為 透明
      sketch.background(255, backgroundAlpha)
    }
    // 若 imgUrl.value .mp4 or .webm
    if (
        imagePathType.value === 'mp4' && imgUrl.value && imgUrl.value !== null && imgUrl.value !== '' ||
        imagePathType.value === 'webm' && imgUrl.value && imgUrl.value !== null && imgUrl.value !== ''
    ) {
      // mp4
      vid = sketch.createVideo(imgUrl.value)
      vid.style('background-color', `${backgroundColor.value}`)
      vid.style('z-index', '-1')
      // mp4
      vid.size(sketch.width, sketch.height);
      vid.position(0,0)
      vid.volume(0);
      vid.loop()
      sketch.background(backgroundColor.value)
    }
  }

  sketch.draw = function() {
    drawPot.value++
    if ( imagePathType.value === 'gif' ||
      imagePathType.value === 'mp4' ||
      imagePathType.value === 'webm'
    ) sketch.clear()

    if (imagePathType.value !== 'gif' &&
        imagePathType.value !== 'mp4' &&
        imagePathType.value !== 'webm') {
      if (imgUrl.value && imgUrl.value !== null && imgUrl.value !== '') {
        sketch.background(0, backgroundAlpha - 15)
        sketch.image(bg, 0, 0, sketch.width, sketch.height)
        // image alpha
        sketch.tint(255, backgroundAlpha - 15)
      } else {
        // 添加 背景色
        sketch.background(...backgroundHsbColor.value, backgroundAlpha)
      }
    }

    // animate

    // 0.1
    // 0.2
    // 0.3
    if (sketch.random(1) < (animateRange.value * 0.7)) {
      fireworks.push(new FireWorkBall(
          sketch.random(sketch.width), //x
          sketch.height, //y
          currentColorArr.arr[Math.floor(sketch.random()*currentColorArr.arr.length)],//color
          sketch.random(7,10), //size
      ));
    }

    for (const particle of particles) {
      particle.draw();
      particle.move();
    }
    for (const firework of fireworks) {
      firework.draw();
      firework.move();
    }

    particles = particles.filter(p => p.active);
    fireworks = fireworks.filter(f => f.active);
    if (particles && particles.length > 450) particles = []
    if (fireworks && fireworks.length > 250) fireworks = []
  }

  if (drawPot.value > 6000) {
    fireworks = []
    particles = []
    drawPot.value = 0
  }

}

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value = new p5(fireworksAnimate, 'Fireworks')
  }
})

watchEffect(() => {
  const {
    HighValue,
    LowValue,
    IsDynamicMode,
    BackgroundColor,
    BackgroundImage,
    Speed: range,
    Colors,
    HighColors,
    LowColors,
  } = effectThemeData

  // 背景色
  let bgColor = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'
  let bgHsbColor = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? rgbToHsb(BackgroundColor) : [0,0,0]

  // 背景色, 背景圖 需 重置動畫
  if (
      backgroundImage.value !== BackgroundImage ||
      backgroundColor.value !== bgColor ||
      backgroundHsbColor.value[0] !== bgHsbColor[0] ||
      backgroundHsbColor.value[1] !== bgHsbColor[1] ||
      backgroundHsbColor.value[2] !== bgHsbColor[2]
  ) {
    backgroundHsbColor.value = bgHsbColor
    backgroundColor.value = bgColor
    imagePathType.value = ''
    backgroundImage.value = BackgroundImage
    if (backgroundImage.value !== '') {
      if (props.controlMode && props.controlMode.toString() === 'true') {
        const pathSplit = backgroundImage.value.split('.')
        imgUrl.value = freeImages[pathSplit[0]]
        imagePathType.value = pathSplit[1]
      } else {
        imgUrl.value = backgroundImage.value.split('#')[0]
        if (imgUrl.value.endsWith('.mp4')) imagePathType.value = 'mp4'
        else if (imgUrl.value.endsWith('.webm')) imagePathType.value = 'webm'
        else if (imgUrl.value.endsWith('.gif')) imagePathType.value = 'gif'
      }
    }
    if (backgroundImage.value === '') {
      imgUrl.value = ''
      imagePathType.value = ''
    }
    // create p5
    if (canvasWrap.value !== 'stop') {
      initAnimate()
      canvasWrap.value = new p5(fireworksAnimate, 'Fireworks')
    }
  }


  // animateSpeed 可以動態更新
  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''
  if (IsDynamicMode.toString() === 'false') {
    animateRange.value = range
    currentColorArr.arr = Colors.map(color => rgbToHsb(color))
  }
  else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    colorHigh.value = HighColors
    colorLow.value = LowColors
    handleGetAnimateHSBAndRange(high.value, low.value, nowTemperature.value, colorHigh.value, colorLow.value)
  }

})

onMounted(() => {
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(fireworksAnimate, 'Fireworks')
})

onUnmounted(() => {
  drawPot.value = 0
  nowTemperature.value = null
  // animateSpeed.value = 10
  backgroundHsbColor.value = [0,0,0]
  backgroundColor.value = 'rgb(0,0,0)'
  imgUrl.value = ''
  imagePathType.value = ''
  backgroundImage.value = ''
  currentColorArr.arr = []
  high.value = null
  low.value = null
  colorHigh.value = []
  colorLow.value = []
  initAnimate()
})

</script>
